"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check16"));
var _Check2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check24"));
var _HBDivider = _interopRequireDefault(require("../HBDivider/HBDivider"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBMenuItemOld = function HBMenuItemOld(_ref) {
  var item = _ref.item,
    closeMenu = _ref.closeMenu,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size;
  var handleClick = function handleClick(ev) {
    if (item.disabled) {
      return;
    }
    closeMenu();
    if ('onClick' in item) {
      item.onClick(ev);
    }
  };
  var ConditionalWrapper = function ConditionalWrapper(_ref2) {
    var children = _ref2.children;
    return item.itemWrapper ? item.itemWrapper({
      children: children
    }) : children;
  };
  if ('title' in item) {
    return /*#__PURE__*/_react["default"].createElement(ConditionalWrapper, null, /*#__PURE__*/_react["default"].createElement(Container, {
      size: size,
      className: className,
      style: item.style,
      onClick: handleClick,
      rightIcon: item.setTextBeforeIcon,
      disabled: item.disabled,
      isSelected: item.isSelected
    }, !item.setTextBeforeIcon && item.icon && /*#__PURE__*/_react["default"].createElement(LeftIcon, null, item.icon), item.title, item.setTextBeforeIcon && item.icon && /*#__PURE__*/_react["default"].createElement(RightIcon, null, item.icon), item.isSelected && function () {
      switch (size) {
        default:
        case 'md':
          return /*#__PURE__*/_react["default"].createElement(Check16Icon, {
            color: _colors["default"].blue20
          });
        case 'lg':
          return /*#__PURE__*/_react["default"].createElement(Check24Icon, {
            color: _colors["default"].blue20
          });
      }
    }()));
  }
  if ('sectionTitle' in item) {
    return /*#__PURE__*/_react["default"].createElement(Section, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
      type: "Body-Tertiary-Small"
    }, item.sectionTitle));
  }
  if ('isDivider' in item) {
    return /*#__PURE__*/_react["default"].createElement(_HBDivider["default"], {
      margin: item.margin
    });
  }
  return null;
};
var _default = exports["default"] = HBMenuItemOld; // ------------- Styles ---------------//
var LeftIcon = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItemOld__LeftIcon",
  componentId: "sc-o6hvl8-0"
})(["height:16px;padding-right:12px;"]);
var RightIcon = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItemOld__RightIcon",
  componentId: "sc-o6hvl8-1"
})(["height:16px;"]);
var Check16Icon = (0, _styledComponents["default"])(_Check["default"]).withConfig({
  displayName: "HBMenuItemOld__Check16Icon",
  componentId: "sc-o6hvl8-2"
})(["height:16px;margin-left:auto;"]);
var Check24Icon = (0, _styledComponents["default"])(_Check2["default"]).withConfig({
  displayName: "HBMenuItemOld__Check24Icon",
  componentId: "sc-o6hvl8-3"
})(["height:24px;margin-left:auto;"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItemOld__Container",
  componentId: "sc-o6hvl8-4"
})(["display:flex;align-items:center;height:", "px;", " padding:0 20px;", " cursor:", ";", " &:hover{background-color:", ";}"], function (_ref3) {
  var size = _ref3.size;
  switch (size) {
    default:
    case 'md':
      return 42;
    case 'lg':
      return 56;
  }
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'lg' ? (0, _styledComponents.css)(["font-size:18px;"]) : '';
}, function (props) {
  return props.rightIcon ? 'justify-content: space-between;' : null;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, (0, _styledIs["default"])('isSelected')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        background-color: ", ";\n    "])), _colors["default"].blue20_08), function (props) {
  return props.disabled ? null : _colors["default"].neutral100;
});
var Section = _styledComponents["default"].div.withConfig({
  displayName: "HBMenuItemOld__Section",
  componentId: "sc-o6hvl8-5"
})(["height:42px;padding:0 15px;display:flex;align-items:flex-end;cursor:default;"]);
//# sourceMappingURL=HBMenuItemOld.js.map